import React from "react"
import Link from "gatsby-link"
import Helmet from "react-helmet"
import Bio from '../components/Bio'
import BlogList from '../components/BlogList'

import photostories_small_logo from './images/photostories_small_logo.gif'
import cest from './images/etusivulle.gif'
import army from './images/moska01_s.jpg'

export default class Index extends React.Component {

  render() {
    return (
      <div>
        <Bio data={this.props.data} />
        <h2>Latest blog articles <Link to="/blogpost">[more...]</Link></h2>
        <BlogList data={this.props.data} />
        <h2>Project archieve</h2>
        <p>These are the projects I've done ages ago. Not maintained or live, but just for the records of history. Enjoy! :)</p>
        <p><img src={photostories_small_logo} style={{marginBottom: 0, marginTop: 6, marginRight: 6, float: 'left', width: 104}} />When I lived in Oulu city, I had a bit more time for my dear photography hobby than nowadays. I created PhotoStories-site to publish the pictures and related stories. The site has been closed for years, but now it is back on-line as archive. <a href="http://projects.juha.net/archive/saint">Enter PhotoStories</a>.</p>
        <p><img src={cest} style={{marginBottom: 0, marginTop: 6, marginRight: 6, float: 'left', width: 104}} />Ten years ago, while I was studying at the university, the web was in it's early days. Way before the concept of blogs, we just had a thing called "homepage". I was anyway excited about the possibility to publish thoughts on-line. This resulted C'est la vie pages (only in Finnish language). <a href="http://projects.juha.net/archive/cestlavie">Enter C'est La Vie</a>.</p>
        <p><img src={army} style={{marginBottom: 0, marginTop: 6, marginRight: 6, float: 'left', width: 104
      }} />In Finland we have a national defence duty, and almost every male is called into the army service. At the end of my service duty, I created this page to maintain the memory of the year in the army. <a href="http://projects.juha.net/archive/saint">Enter SA-INT</a>.</p>
      </div>
    )
  }
}

export const pageQuery = graphql`
  query IndexQuery {
    site {
      siteMetadata {
        authorName
      }
    }
    allMarkdownRemark(sort: { fields: [frontmatter___date], order: DESC }, limit: 5) {
      edges {
        node {
          fields {
            slug
          }
          frontmatter {
            title
            description
            date
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/index.js